import { PersistenceDimensionKey, WellbeingDimensionKey } from './AssessmentIndex.types';

export const PERSISTENCE_DIMENSIONS: Array<{ key: PersistenceDimensionKey; label: string }> = [
  { key: 'personalWellness', label: 'Personal Wellness' },
  { key: 'campusBelonging', label: 'Campus Belonging' },
  { key: 'academicMomentum', label: 'Academic Momentum' },
  { key: 'lifeStability', label: 'Life Stability' },
];

export const WELLBEING_DIMENSIONS: Array<{ key: WellbeingDimensionKey; label: string }> = [
  { key: 'emotional', label: 'Emotional' },
  { key: 'spiritual', label: 'Spiritual' },
  { key: 'environmental', label: 'Environmental' },
  { key: 'occupational', label: 'Occupational' },
  { key: 'financial', label: 'Financial' },
  { key: 'social', label: 'Social' },
  { key: 'physical', label: 'Physical' },
  { key: 'intellectual', label: 'Intellectual' },
];

export const WELLBEING_COLOR = '#6F70F4';
export const WELLBEING_FILL = 'rgba(111, 112, 244, 0.22)';
export const PERSISTENCE_COLOR = '#1FA82E';
export const PERSISTENCE_FILL = 'rgba(31, 168, 46, 0.22)';
export const RADAR_BAND_COLOR = '#F1F2F4';
export const TRIAGE_PANEL_COLOR = '#F3F4FC';
export const TRIAGE_ACTIVE_COLOR = '#F8D1CE';
export const TRIAGE_DANGER_COLOR = '#C92D28';
export const TRIAGE_LABEL_COLOR = '#ED5C50';
export const TRIAGE_POSITIVE_ACTIVE_COLOR = '#E5F4E4';
export const TRIAGE_POSITIVE_MARKER_COLOR = '#2D6A62';
export const TRIAGE_WARNING_ACTIVE_COLOR = '#FFF8CC';
export const TRIAGE_WARNING_MARKER_COLOR = '#D08700';
export const DELTA_DECREASE_COLOR = '#B83A3D';
